// extracted by mini-css-extract-plugin
export var active = "_i3-7";
export var blink = "_i3-8";
export var dropDownSelector = "_i3-4";
export var dropDownWrapper = "_i3-3";
export var fakeCursor = "_i3-6";
export var fontSizeButton = "_i3-9";
export var formQuillEditor = "_i3-0";
export var pressed = "_i3-a";
export var qlBlank = "_i3-1";
export var textFormattingToolbar = "_i3-2";
export var textToolbarOption = "_i3-5";